<template>
  <div class="chat-preview" :class="{ 'expanded-chat-preview': previewWidth, 'no-top-shadow': listBarFilteredByStep }">
    <!-- 收起状态 -->
    <div class="chat-preview-unexpanded" v-if="!previewWidth">
      <!-- 收起/展开按钮 -->
      <div class="chat-preview-button" @click="changeWidth">
        <img
          src="../assets/images/chatpreview/button_open.png"
          alt="button_open"
        />
      </div>
      <!-- 竖向步骤列表 -->
      <div class="vertical-step-list">
        <div
          class="step-item"
          v-for="(item, index) in stepList"
          :key="index"
          :class="getStepItemClass(index)"
          :style="getStepItemStyle(index)"
          @click="handleStepClick(item)"
        >
          <div class="step-item-image">
            <img :src="getStepImage(index)" />
          </div>
          <div class="step-item-text">
            {{ item.stage_name }}
          </div>
        </div>
      </div>
    </div>
    <!-- 展开状态 -->
    <div class="chat-preview-expanded" v-else>
      <!-- 展开顶部 -->
      <div class="chat-preview-expanded-top" :class="{ 'top-background-unset': listBarFilteredByStep }">
        <!-- 收起/展开按钮 -->
        <div class="chat-preview-button" @click="changeWidth">
          <img
            src="../assets/images/chatpreview/button_open.png"
            alt="button_open"
          />
        </div>
        <!-- 水平步骤条 -->
        <div class="horizontal-step-list">
          <div
            class="step-item"
            v-for="(item, index) in stepList"
            :key="index"
            :class="getStepItemClass(index)"
            :style="getStepItemStyle(index)"
            @click="handleStepClick(item)"
          >
            <div class="step-item-content">
              <div class="step-item-image">
                <img :src="getStepImage(index)" />
              </div>
              <div class="step-item-text">{{ item.stage_name }}</div>
            </div>  
          </div>
        </div>   
      </div>

      <!-- 列表栏 -->
      <div class="list-bar" :class="{ 'to-boder-radius': listBarFilteredByStep, 'first-step-selected': isFirstStepSelected }">
        <div v-for="(item, index) in listBarList" :key="index">
          <!-- 列表项头部 -->
          <div
            class="list-item"
            :class="{ 'list-item-expanded': isItemExpanded(index) }"
          >
            <div
              class="list-item-content"
              :class="{ 'list-item-content-expanded': isItemExpanded(index) }"
              @click="toggleListItem(index)"
            >
              <div
                class="list-item-icon"
                :class="{ 'list-item-icon-expanded': isItemExpanded(index) }"
              >
                <img :src="getListIcon(index)" class="list-icon-img" />
              </div>
              <div
                class="list-item-text"
                :class="{ 'list-item-text-expanded': isItemExpanded(index) }"
              >
                {{ item.label }}
              </div>
              <div class="list-item-arrow">
                <img :src="getListArrow(index)" />
              </div>
            </div>
          </div>
          <!-- 展开内容区域 -->
          <div class="list-item-content-area" v-show="isItemExpanded(index)">
            <component
              :is="getListItemComponent(item)"
              v-if="isItemExpanded(index)"
              :key="`${item.key}-${conversationId || 'default'}`"
              :preview-data="getPreviewDataForComponent(item)"
              :company-name="getCompanyName()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import config from "@/utils/config";
import { getSideScreenInit } from "@/api"; // 获取初始配置信息V2.0
import { fetchEventSource } from "@microsoft/fetch-event-source"; // 获取SSE配置信息V2.0
import request from "@/utils/request";
// 公共组件
import ProjectInfo from "@/components/ChatPreview/common/ProjectInfo.vue";
import MaterialList from "@/components/ChatPreview/common/MaterialList.vue";
import EmissionSource from "@/components/ChatPreview/common/EmissionSource.vue";
import DataSummary from "@/components/ChatPreview/common/DataSummary.vue";
import DataCalculate from "@/components/ChatPreview/common/DataCalculate.vue";
import DataReport from "@/components/ChatPreview/common/DataReport.vue";
import VerifyCertify from "@/components/ChatPreview/common/VerifyCertify.vue";
// TPC 专用组件
// TZJ 专用组件
import ProductOutput from "@/components/ChatPreview/tzj/ProductOutput.vue";
import DataQuality from "@/components/ChatPreview/tzj/DataQuality.vue";

export default {
  name: "ChatPreview",

  components: {
    // 公共组件
    ProjectInfo,
    MaterialList,
    EmissionSource,
    DataSummary,
    VerifyCertify,
    DataCalculate,
    DataReport,
    // TZJ 专用组件
    ProductOutput,
    DataQuality,
  },

  props: {
    conversationId: String,
  },

  data() {
    return {
      previewWidth: false, // ChatPreview是否展开
      stepList: [], // 步骤列表
      listBarList: [], // 内容列表
      expandedItems: [], // 展开的列表项索引数组
      listBarFilteredByStep: null, // 若为步骤对象则列表只显示该步骤的 stageShowList；null 表示使用默认列表（所有已完成步骤的 stageShowList 并集）
      previewData: {}, // 预览数据，包含各个节点的数据
      sideScreenSSEController: null, // SSE 请求的 AbortController
      sideScreenSSEConversationId: null, // 当前右边屏 SSE 对应的 conversationId，用于去重
    };
  },

  methods: {
    ...mapMutations([
      // "setToken",
      // "setShowLogin",
      // "setUserInfo",
      "setPreviewExpanded",
    ]),

    // 初始化步骤列表
    initStepList() {
      const stepConfig = config.stepListConfig[this.accessType];
      if (stepConfig && Array.isArray(stepConfig)) {
        // 从配置中初始化步骤列表，包含 stageShowList
        this.stepList = stepConfig.map((step) => ({
          ...step,
          stageShowList: step.stageShowList || [],
        }));
      } else {
        this.stepList = [];
      }
      // 初始化列表栏
      this.updateListBar();
    },

    // 展开/收起右边屏
    changeWidth() {
      const willExpand = !this.previewWidth;
      this.previewWidth = !this.previewWidth;  // 切换展开状态
      this.setPreviewExpanded(this.previewWidth);  // 设置父组件的展开状态
      this.$parent.handleLayoutChange(); // 通知父组件重新计算布局，更新视口变化
      // 点击展开按钮展开时：恢复默认列表，保持当前默认显示列表
      if (willExpand) {
        this.listBarFilteredByStep = null;
        this.expandedItems = [];
        this.updateListBar();
      }
    },

    // 获取步骤图片（根据状态返回不同图标）
    getStepImage(index) {
      const stepItem = this.stepList[index];
      const status = stepItem ? stepItem.stage_status : 0;
      // 完成状态使用 success 图标，其他使用 init 图标
      switch (status) {
        case 0:
          return require(`@/assets/images/chatpreview/step_init_${
            index + 1
          }.svg`);
        case 1:
          return require(`@/assets/images/chatpreview/step_pending_${
            index + 1
          }.gif`);
        case 2:
          return require(`@/assets/images/chatpreview/step_success_${
            index + 1
          }.svg`);
      }
    },

    // 获取步骤项文字颜色样式（含“按步骤筛选”时的选中高亮）
    getStepItemClass(index) {
      const stepItem = this.stepList[index];
      const status = stepItem ? stepItem.stage_status : 0;
      const isStepSelected =
        this.listBarFilteredByStep &&
        stepItem &&
        this.listBarFilteredByStep.stage_code === stepItem.stage_code;
      return {
        "step-init": status === 0,
        "step-pending": status === 1,
        "step-success": status === 2,
        "step-selected": isStepSelected,
      };
    },

    // 获取步骤项未完成点击权限
    getStepItemStyle(index) {
      const stepItem = this.stepList[index];
      const status = stepItem ? stepItem.stage_status : 0;
      if (status === 0) {
        return {
          cursor: "not-allowed",
          pointerEvents: "none",
        };
      }
      return {};
    },

    // API：初始化右边屏数据
    getStepList() {
      getSideScreenInit(this.conversationId, {
        access_type: this.accessType,
      })
        .then((res) => {
          if (res.data.code === 200) {
            const stepListData = res.data.data.stages;
            const stageData = res.data.data.stage_data || [];

            if (stepListData && Array.isArray(stepListData)) {
              // 将 API 返回的数据映射为步骤对象数组，并按 stage_index 排序
              this.stepList = stepListData
                .map((stage) => ({
                  id: stage.id,
                  conversation_id: stage.conversation_id,
                  stage_name: stage.stage_name,
                  stage_code: stage.stage_code,
                  stage_index: stage.stage_index,
                  stage_status: stage.stage_status,
                  // 从配置中获取 stageToListMapping
                  stageToListMapping: this.getStageToListMapping(
                    stage.stage_code
                  ),
                  // 从配置中获取 stageShowList
                  stageShowList: this.getStageShowList(stage.stage_code),
                }))
                .sort((a, b) => a.stage_index - b.stage_index);

              // 更新列表栏，根据步骤状态动态显示
              this.updateListBar();
            }

            // 处理 stage_data，将数据按 node_code 存储到 previewData 中
            if (stageData && Array.isArray(stageData)) {
              const previewDataMap = {};
              stageData.forEach((item) => {
                if (item.node_code && item.data) {
                  previewDataMap[item.node_code] = item.data;
                }
              });
              // 使用 Vue.set 或直接赋值新对象来确保响应式
              this.previewData = { ...previewDataMap };
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 根据步骤名称获取对应的列表项映射
    getStageToListMapping(stageCode) {
      const stepConfig = config.stepListConfig[this.accessType];
      if (stepConfig && Array.isArray(stepConfig)) {
        const step = stepConfig.find((s) => s.stage_code === stageCode);
        return step ? step.stageToListMapping : null;
      }
      return null;
    },

    // 根据步骤名称获取对应的stageShowList
    getStageShowList(stageCode) {
      const stepConfig = config.stepListConfig[this.accessType];
      if (stepConfig && Array.isArray(stepConfig)) {
        const step = stepConfig.find((s) => s.stage_code === stageCode);
        return step ? step.stageShowList || [] : [];
      }
      return [];
    },

    // 处理步骤点击事件：只显示该步骤的 stageShowList，并打开对应列表项；再次点击同一步骤时恢复默认
    handleStepClick(stepItem) {
      // 如果状态为 0（未开始），则不可点击
      const status = stepItem.stage_status || 0;
      if (status === 0) {
        return;
      }

      // 再次点击同一步骤时：恢复默认状态（列表显示所有已完成步骤的 stageShowList 并集，收起展开项）
      const isSameStep =
        this.listBarFilteredByStep &&
        this.listBarFilteredByStep.stage_code === stepItem.stage_code;
      if (isSameStep) {
        this.listBarFilteredByStep = null;
        this.expandedItems = [];
        this.updateListBar();
        return;
      }

      // 点击步骤时：进入“按步骤筛选”模式，列表只显示该步骤的 stageShowList
      this.listBarFilteredByStep = stepItem;
      this.updateListBarByStep(stepItem);

      // 确保预览区域已展开
      if (!this.previewWidth) {
        this.previewWidth = true;
        this.setPreviewExpanded(true);
        this.$parent.handleLayoutChange(); // 通知父组件重新计算布局，更新视口变化
        // 等待DOM更新后再展开列表项
        this.$nextTick(() => {
          this.openListItemByStep(stepItem);
        });
      } else {
        this.openListItemByStep(stepItem);
      }
    },

    // 初始化列表栏 - 按order排序
    initListBar() {
      // 如果 stepList 已存在且有数据，使用动态更新方式
      if (this.stepList && this.stepList.length > 0) {
        this.updateListBar();
      } else {
        // 否则使用默认配置（所有列表项都显示）
        const listConfig = config.listBarConfig[this.accessType];
        if (listConfig && Array.isArray(listConfig)) {
          // 按order字段排序，确保顺序正确
          this.listBarList = [...listConfig].sort(
            (a, b) => (a.order || 0) - (b.order || 0)
          );
        } else {
          this.listBarList = [];
        }
      }
    },

    // 根据步骤状态动态更新列表栏（默认显示：所有已完成步骤的 stageShowList 并集）
    updateListBar() {
      if (this.listBarFilteredByStep) {
        // 当前处于“按步骤筛选”模式，不在此处覆盖，由 updateListBarByStep 维护
        return;
      }
      // 收集所有 stage_status !== 0 的步骤的 stageShowList
      const visibleKeys = new Set();
      this.stepList.forEach((step) => {
        if (
          step.stage_status !== 0 &&
          step.stageShowList &&
          Array.isArray(step.stageShowList)
        ) {
          step.stageShowList.forEach((key) => {
            visibleKeys.add(key);
          });
        }
      });

      // 从配置中筛选出需要显示的列表项
      const listConfig = config.listBarConfig[this.accessType];
      if (listConfig && Array.isArray(listConfig)) {
        this.listBarList = listConfig
          .filter((item) => visibleKeys.has(item.key))
          .sort((a, b) => (a.order || 0) - (b.order || 0));
      } else {
        this.listBarList = [];
      }
    },

    // 按步骤筛选列表栏：只显示该步骤的 stageShowList
    updateListBarByStep(stepItem) {
      const visibleKeys = new Set(
        (stepItem.stageShowList && Array.isArray(stepItem.stageShowList))
          ? stepItem.stageShowList
          : []
      );
      const listConfig = config.listBarConfig[this.accessType];
      if (listConfig && Array.isArray(listConfig)) {
        this.listBarList = listConfig
          .filter((item) => visibleKeys.has(item.key))
          .sort((a, b) => (a.order || 0) - (b.order || 0));
      } else {
        this.listBarList = [];
      }
    },

    // 根据步骤对象打开对应的列表项
    openListItemByStep(stepItem) {
      const targetKey = stepItem.stageToListMapping;
      if (!targetKey) {
        console.warn(
          `No mapping found for step: ${stepItem.stage_code} in ${this.accessType}`
        );
        return;
      }

      // 在列表中找到对应的列表项索引
      const listItemIndex = this.listBarList.findIndex(
        (item) => item.key === targetKey
      );

      if (listItemIndex === -1) {
        console.warn(
          `List item with key "${targetKey}" not found for step "${stepItem.stage_code}"`
        );
        return;
      }

      // 先收起所有已展开的项，然后展开目标项（最多只能展开一个）
      this.expandedItems = [listItemIndex];

      // 滚动到对应的列表项位置
      this.$nextTick(() => {
        this.scrollToListItem(listItemIndex);
      });
    },

    // 滚动到指定的列表项
    scrollToListItem(index) {
      const listBarElement = this.$el.querySelector(".list-bar");
      if (!listBarElement) return;

      const listItemElement = listBarElement.children[index];
      if (listItemElement) {
        listItemElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    },

    // 获取列表项图标
    getListIcon(index) {
      const item = this.listBarList[index];
      return require(`@/assets/images/chatpreview/${item.icon}.svg`);
    },

    // 获取列表项箭头
    getListArrow(index) {
      return this.isItemExpanded(index)
        ? require(`@/assets/images/chatpreview/arrow-down.svg`)
        : require(`@/assets/images/chatpreview/arrow-right.svg`);
    },

    // 获取列表项对应的组件（支持动态组件加载）
    getListItemComponent(item) {
      if (!item || !item.component) {
        return "ProjectInfo"; // 默认组件
      }

      // 检查组件是否已注册
      const componentName = item.component;
      if (this.$options.components[componentName]) {
        return componentName;
      }

      // 如果组件未注册，尝试动态加载
      // 这里可以根据需要实现动态导入逻辑
      console.warn(
        `Component ${componentName} not found, using default ProjectInfo`
      );
      return "ProjectInfo";
    },

    // 切换列表项展开/收起（最多只能展开一个）
    toggleListItem(index) {
      const expandedIndex = this.expandedItems.indexOf(index);
      if (expandedIndex > -1) {
        // 如果已展开，则收起
        this.expandedItems = [];
      } else {
        // 如果未展开，先收起其他所有项，然后展开当前项
        this.expandedItems = [index];
      }
    },

    // 判断列表项是否展开
    isItemExpanded(index) {
      return this.expandedItems.indexOf(index) > -1;
    },

    // 获取组件对应的预览数据
    getPreviewDataForComponent(item) {
      if (!item || !item.apiNodeCodeMap) {
        return null;
      }
      // 根据 item.apiNodeCodeMap（来自listBarConfig）获取对应的预览数据
      return this.previewData[item.apiNodeCodeMap] || null;
    },

    // 从项目基本信息节点获取企业名称（供 VerifyCertify 子组件使用）
    getCompanyName() {
      const projectInfo = this.previewData.project_info;
      if (!projectInfo || !projectInfo.company_name) {
        return "";
      }
      return projectInfo.company_name.value || "";
    },

    // SSE 请求：获取右边屏动态数据
    async startSideScreenSSE() {
      // 如果没有 conversationId，无法启动 SSE
      if (!this.conversationId) {
        console.warn("无法启动右边屏 SSE：conversationId 为空");
        return;
      }

      // 如果当前已经有相同 conversationId 的 SSE 连接在运行，不重复启动
      if (this.sideScreenSSEConversationId === this.conversationId && this.sideScreenSSEController) {
        // console.log("右边屏 SSE 已启动，跳过重复启动");
        return;
      }

      // 如果已有 SSE 请求在进行（不同 conversationId），先停止
      if (this.sideScreenSSEController) {
        // console.log("停止旧的右边屏 SSE 连接");
        this.sideScreenSSEController.abort();
      }

      // 创建新的 AbortController
      this.sideScreenSSEController = new AbortController();
      this.sideScreenSSEConversationId = this.conversationId; // 记录当前 SSE 对应的 conversationId
      const signal = this.sideScreenSSEController.signal; // AbortController 信号

      // 获取 baseURL
      const baseURL = request.defaults.baseURL;
      const url = `${baseURL}/agent/side-navigation`;

      // 准备请求体
      const requestBody = {
        conversation_id: this.conversationId,
        user_id: this.userInfo?.user_id,
      };

      // 开始 SSE 请求
      await fetchEventSource(url, {
        method: "POST",
        signal: signal,
        reconnect: false, // 不自动重连
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.token}`
        },
        body: JSON.stringify(requestBody),
        openWhenHidden: true,
        onmessage: async (event) => {
          try {
            const data = JSON.parse(event.data);
            
            // 第一步：处理 stage_data 更新步骤状态
            if (data.stage_data && Array.isArray(data.stage_data)) {
              await this.updateStepStatusFromSSE(data.stage_data);
            }

            // 第二步：处理 expanded_node 更新展开的列表项（确保步骤状态更新完成后再展开）
            if (data.expanded_node) {
              await this.updateExpandedNodeFromSSE(data.expanded_node);
            }

            // 第三步：处理 stage_node_data 更新预览数据（确保列表项展开后再更新预览数据）
            if (data.stage_node_data && Array.isArray(data.stage_node_data)) {
              this.updatePreviewDataFromSSE(data.stage_node_data);
            }

            // chatPage 打印日志
            if (data.content) {
              // 将content按\n分割成多条日志，通过事件传递给父组件
              const logLines = data.content.split('\n').filter(line => line.trim());
              if (logLines.length > 0) {
                this.$emit('new-logs', logLines);
              }
            }
          } catch (error) {
            console.error("解析 SSE 数据失败:", error);
          }
        },
        onclose: () => {
          // console.log("右边屏 SSE 连接已关闭");
          this.sideScreenSSEController = null;
          this.sideScreenSSEConversationId = null;
        },
        onerror: (error) => {
          console.error("右边屏 SSE 请求错误:", error);
          this.sideScreenSSEController = null;
          this.sideScreenSSEConversationId = null;
        },
        onopen: async (response) => {
          if (response.status === 401) {
            this.sideScreenSSEController.abort();
            this.sideScreenSSEController = null;
            this.sideScreenSSEConversationId = null;
            // 可以在这里处理登录失效的情况
          } else {
            console.log("右边屏 SSE 连接已建立，sideScreenSSEConversationId:", this.sideScreenSSEConversationId);
          }
        },
      });
    },

    // 根据 SSE 返回的 stage_data 更新步骤状态
    updateStepStatusFromSSE(stageData) {
      return new Promise((resolve) => {
        if (!stageData || !Array.isArray(stageData)) {
          resolve();
          return;
        }

        // 如果 stepList 还没有初始化，先初始化
        if (!this.stepList || this.stepList.length === 0) {
          this.initStepList();
        }

        // 遍历 SSE 返回的 stage_data
        stageData.forEach((stageItem) => {
          const { stage_code, stage_status } = stageItem;
          
          if (!stage_code || stage_status === undefined) {
            return;
          }

          // 在 stepList 中找到对应的步骤并更新状态
          const stepIndex = this.stepList.findIndex(
            (step) => step.stage_code === stage_code
          );

          if (stepIndex !== -1) {
            // 使用 Vue.set 确保响应式更新
            this.$set(this.stepList[stepIndex], "stage_status", stage_status);
          } else {
            // 如果找不到对应的步骤，可能是 stepList 还没有从 API 获取到，记录日志
            console.warn(`未找到 stage_code 为 ${stage_code} 的步骤，可能 stepList 尚未初始化`);
          }
        });

        // 如果状态变化，更新列表栏，等待 DOM 更新完成后再 resolve
        this.$nextTick(() => {
          this.updateListBar();
          // 再次等待 DOM 更新，确保列表栏更新完成
          this.$nextTick(() => {
            resolve();
          });
        });
      });
    },

    // 根据 SSE 返回的 expanded_node 更新展开的列表项
    updateExpandedNodeFromSSE(expandedNode) {
      return new Promise((resolve) => {
        // 如果 expanded_node 为空字符串，收起所有展开的项
        if (!expandedNode || expandedNode === "") {
          this.expandedItems = [];
          resolve();
          return;
        }

        // 如果 listBarList 还没有初始化，先初始化
        if (!this.listBarList || this.listBarList.length === 0) {
          this.initListBar();
        } 

        // 确保预览区域已展开
        if (!this.previewWidth) {
          this.previewWidth = true;
          this.setPreviewExpanded(true);
          this.$parent.handleLayoutChange(); // 通知父组件重新计算布局，更新视口变化
        }

        // 在 listBarList 中找到对应的列表项索引
        let listItemIndex = this.listBarList.findIndex(
          (item) => item.apiNodeCodeMap === expandedNode
        );

        if (listItemIndex === -1) {
          console.warn(
            `未找到 apiNodeCodeMap 为 ${expandedNode} 的列表项，可能列表栏尚未初始化`
          );
          resolve();
          return;
        }

        // 更新展开的列表项（最多只能展开一个）
        this.expandedItems = [listItemIndex];

        // 等待 DOM 更新完成，确保列表项已展开后再 resolve
        this.$nextTick(() => {
          this.scrollToListItem(listItemIndex);
          // 再次等待 DOM 更新，确保列表项展开动画完成
          this.$nextTick(() => {
            resolve();
          });
        });
      });
    },

    // 根据 SSE 返回的 stage_node_data 更新预览数据
    updatePreviewDataFromSSE(stageNodeData) {
      if (!stageNodeData || !Array.isArray(stageNodeData)) {
        return;
      }

      // 遍历 stage_node_data 数组
      stageNodeData.forEach((nodeData) => {
        const { node_code, patches } = nodeData;

        if (!node_code || !patches || !Array.isArray(patches)) {
          return;
        }

        // 确保 previewData 中存在对应的 node_code
        if (!this.previewData[node_code]) {
          // 如果不存在，初始化为空对象
          console.log("previewData中不存在node_code", node_code);
        }

        // 遍历 patches 数组，更新对应的字段
        patches.forEach((patch) => {
          const { path, value, extra } = patch;

          if (!path) {
            return;
          }

          // 支持嵌套路径（如 "enterprise.business_license"）
          this.updateNestedPath(node_code, path, value);

          // 如果存在 extra 字段，更新 path 对应对象中的 extra 字段
          if (extra && typeof extra === "object") {
            this.updateNestedPathExtra(node_code, path, extra);
          }
        });
      });
    },

    // 更新嵌套路径的值
    updateNestedPath(nodeCode, path, value) {
      // 将路径拆分为数组（如 "enterprise.business_license" -> ["enterprise", "business_license"]）
      const pathParts = path.split(".");

      // 获取目标对象（previewData[nodeCode]）
      let targetObj = this.previewData[nodeCode];

      // 如果不是嵌套路径（只有一个部分），直接处理
      if (pathParts.length === 1) {
        const key = pathParts[0];
        if (targetObj[key]) {
          // 如果已存在，只更新 value，保持 label 不变
          this.$set(targetObj[key], "value", value || "");
        } else {
          // 如果不存在，打印日志
          console.log("previewData中不存在key", key);
        }
        return;
      }

      // 处理嵌套路径：遍历路径的每一部分（除了最后一部分）
      for (let i = 0; i < pathParts.length - 1; i++) {
        const key = pathParts[i];

        // 如果当前层级不存在，打印日志
        if (!targetObj[key]) {
          console.log("previewData中不存在key", key);
        }

        // 确保当前层级是对象
        if (typeof targetObj[key] !== "object" || targetObj[key] === null) {
          console.log("previewData中key不是对象", key);
        }

        // 移动到下一层级
        targetObj = targetObj[key];
      }

      // 处理最后一部分（实际要更新的字段）
      const finalKey = pathParts[pathParts.length - 1];
      if (targetObj[finalKey]) {
        // 如果已存在，只更新 value，保持 label 不变
        this.$set(targetObj[finalKey], "value", value || "");
      } else {
        // 如果不存在，打印日志
        console.log("previewData中不存在key", finalKey);
      }
    },

    // 更新嵌套路径对应对象中的 extra 字段
    updateNestedPathExtra(nodeCode, path, extra) {
      // 将路径拆分为数组（如 "enterprise.business_license" -> ["enterprise", "business_license"]）
      const pathParts = path.split(".");

      // 获取目标对象（previewData[nodeCode]）
      let targetObj = this.previewData[nodeCode];

      if (!targetObj) {
        console.log("previewData中不存在node_code", nodeCode);
        return;
      }

      // 如果不是嵌套路径（只有一个部分），直接处理
      if (pathParts.length === 1) {
        const key = pathParts[0];
        if (targetObj[key]) {
          // 遍历 extra 对象，将每个 key-value 更新到目标对象中
          Object.keys(extra).forEach((extraKey) => {
            this.$set(targetObj[key], extraKey, extra[extraKey]);
          });
        } else {
          // 如果不存在，打印日志
          console.log("previewData中不存在key", key);
        }
        return;
      }

      // 处理嵌套路径：遍历路径的每一部分（除了最后一部分）
      for (let i = 0; i < pathParts.length - 1; i++) {
        const key = pathParts[i];

        // 如果当前层级不存在，打印日志并返回
        if (!targetObj[key]) {
          console.log("previewData中不存在key", key);
          return;
        }

        // 确保当前层级是对象
        if (typeof targetObj[key] !== "object" || targetObj[key] === null) {
          console.log("previewData中key不是对象", key);
          return;
        }

        // 移动到下一层级
        targetObj = targetObj[key];
      }

      // 处理最后一部分（实际要更新的字段）
      const finalKey = pathParts[pathParts.length - 1];
      if (targetObj[finalKey]) {
        // 遍历 extra 对象，将每个 key-value 更新到目标对象中
        Object.keys(extra).forEach((extraKey) => {
          this.$set(targetObj[finalKey], extraKey, extra[extraKey]);
        });
      } else {
        // 如果不存在，打印日志
        console.log("previewData中不存在key", finalKey);
      }
    },

    // 清空右边屏数据
    clearInfo() {
      this.expandedItems = [];
      this.listBarFilteredByStep = null;
      this.previewData = {};
      this.initStepList();
      this.initListBar();
      // 停止 SSE 请求
      if (this.sideScreenSSEController) {
        this.sideScreenSSEController.abort();
        this.sideScreenSSEController = null;
      }
      this.sideScreenSSEConversationId = null;
    },
  },

  computed: {
    ...mapState(["token", "userInfo", "accessType", "chatPreviewWidth"]),
    // 判断是否是第一个步骤项被选中
    isFirstStepSelected() {
      if (!this.listBarFilteredByStep || !this.stepList || this.stepList.length === 0) {
        return false;
      }
      return this.stepList[0] && 
             this.stepList[0].stage_code === this.listBarFilteredByStep.stage_code;
    },
  },

  // 监听 conversationId 变化
  watch: {
    // 监听 accessType 变化，更新步骤列表
    accessType: {
      immediate: true,
      handler() {
        // this.initListBar(); // 初始化列表栏
      },
    },
    // 监听 conversationId 变化，重新获取步骤状态
    conversationId: {
      immediate: true,
      handler(newId, oldId) {
        if (this.conversationId) {
          // 清空旧的预览数据，然后获取新数据
          this.previewData = {};
          if(this.accessType != 'tz') {
            this.getStepList();
            // 如果 conversationId 发生变化，且不是首次初始化，启动右边屏 SSE
            // 注意：首次初始化时 oldId 为 undefined，此时不启动 SSE（由 ChatPage 统一管理）
            if (oldId !== undefined && oldId !== newId) {
              this.$nextTick(() => {
                this.startSideScreenSSE();
              });
            }
          }
        } else {
          // 如果 conversationId 为空，恢复初始配置
          this.previewData = {};
          if(this.accessType != 'tz') {
            this.initStepList();
          }
          // 停止 SSE 连接
          if (this.sideScreenSSEController) {
            this.sideScreenSSEController.abort();
            this.sideScreenSSEController = null;
            this.sideScreenSSEConversationId = null;
          }
        }
      },
    },
  },

  mounted() {
    // 创建新对话时关闭右侧分屏
    this.$root.$on('preview-success-Close', () => {
      this.previewWidth = false;
    });
  },

  beforeDestroy() {
    // 清理 SSE 请求
    if (this.sideScreenSSEController) {
      this.sideScreenSSEController.abort();
      this.sideScreenSSEController = null;
    }
    this.sideScreenSSEConversationId = null;
    console.log("关闭右边屏SSE");
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 右边屏折叠宽度 */
.chat-preview {
  width: 92px;
  height: calc(100vh - 24px);
  background-color: #fff;
  position: fixed;
  right: 12px;
  top: 12px;
  border-radius: 15px;
  box-shadow: -3px 4px 15px 0px rgba(147, 169, 167, 0.2);

  /* 点击横向步骤条时，移除顶部 box-shadow */
  &.no-top-shadow {
    box-shadow: none;
  }
}

/* 右边屏展开宽度 */
.expanded-chat-preview {
  width: 690px;
  background-color: unset;
}

/* 右边屏折叠状态内容样式 */
.chat-preview-unexpanded {
  width: 100%;
  height: 100%;

  .chat-preview-button {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 35px;
    right: 34px;
  }

  /* 竖向步骤列表样式 */
  .vertical-step-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    gap: 40px;
    padding-top: 119px;

    /* 步骤项样式 */
    .step-item {
      width: 58px;
      height: 58px;
      padding: 2px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;

      .step-item-image {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
      }

      .step-item-text {
        font-size: 12px;
        font-weight: 700;
      }
    }

    .step-item:hover { 
      cursor: pointer;
      background-color: rgba(219, 232, 245, 1);
      // border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      // box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
  }
}

.step-item[style*="pointer-events: none"]:hover {
  cursor: not-allowed;
}

.step-item.step-init {
  color: #d0d9d9;
}

.step-item.step-pending {
  color: #3f4f4e;
}

.step-item.step-success {
  color: #3f4f4e;
}

/* 右边屏展开状态内容样式 */
.chat-preview-expanded {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

/* 展开顶部样式 */
.chat-preview-expanded-top {
  width: 100%;
  background-color: #fff;
  border-radius: 15px 15px 0 0;
  
  /* 点击步骤时，背景设为 unset */
  &.top-background-unset {
    background-color: unset;
  }

  /* 收起/展开按钮样式 */
  .chat-preview-button {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 35px;
    right: 34px;
  }

  /* 横向步骤条样式 */
  .horizontal-step-list{
    width: 560px;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: space-evenly;

    /* 步骤项样式 */
    .step-item {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding-bottom: 4px;

      .step-item-content {
        width: 60px;
        height: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

          .step-item-image {
            width: 28px;
            height: 28px;
            flex-shrink: 0;
          }

          .step-item-text {
            font-size: 14px;
            font-weight: 700;
          }
      }
    }

    .step-item-content:hover {
      cursor: pointer;
    }

    // 父级step-item未选中时，鼠标悬浮时，背景色变为浅蓝色，圆角为10px
    .step-item:not(.step-selected) .step-item-content:hover {
      cursor: pointer;
      background-color: rgba(219, 232, 245, 1);
      border-radius: 10px;
    }

    /* 步骤项选中态，对应“按步骤筛选”时的点击效果 */
    /* 第一个 */
    .step-item.step-selected:first-child {
      position: relative;
      /* 使用伪元素实现白色背景和右侧斜切边 */
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -10%;
        right: 0;
        bottom: 0;
        width: 130%;
        height: 101%;
        background-image: url('@/assets/images/chatpreview/step_selected_1.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        border-radius: 12px 0 0 0;
        z-index: -1;
      }
    }

    /* 中间 */
    .step-item.step-selected:not(:first-child):not(:last-child) {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        width: 160%;
        height: 101%;
        top: 0;
        left: -30%;
        right: 30%;
        bottom: 0;
        background-image: url('@/assets/images/chatpreview/step_selected_2.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        z-index: -1;
      }
    }

    /* 最后一个 */
    .step-item.step-selected:last-child {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -30%;
        right: 0;
        bottom: 0;
        width: 130%;
        height: 101%;
        background-image: url('@/assets/images/chatpreview/step_selected_3.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        border-radius: 0 12px 0 0;
        z-index: -1;
      }
    }
  }
}

/* 列表栏样式 */
.list-bar {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 0 0 15px 15px;
  padding: 4px 20px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &.to-boder-radius {
    border-radius: 15px;
  }
  
  /* 点击第一个材料时，左上角没有圆角，优先级高于 to-boder-radius */
  &.first-step-selected {
    border-radius: 0 15px 15px 15px;
  }
}

/* 列表项样式 */
.list-item {
  width: 100%;
  height: 60px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  padding-top: 20px;
}

.list-item-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  background: rgba(243, 247, 250, 1);
  border-radius: 16px 16px 0 0;
  cursor: pointer;

  /* 鼠标悬浮时未展开列表项 */
  &:hover:not(.list-item-content-expanded) {
    background: linear-gradient(90.56deg, #E3F0FC 11.32%, #BDD8F7 43.26%, #E4FAFB 75.63%, #CFF6F4 98.2%);

    .list-icon-img{
      /* 浅灰 */
      filter: brightness(0) saturate(100%) invert(67%) sepia(0%) saturate(1341%) hue-rotate(177deg) brightness(92%) contrast(88%);
    }

    .list-item-text{
      color: rgba(90, 102, 114, 1);
    }

    .list-item-arrow{
      filter: brightness(0) saturate(100%) invert(67%) sepia(0%) saturate(1341%) hue-rotate(177deg) brightness(92%) contrast(88%);
    }
  }
}

.list-item-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  position: relative;
}

.list-item-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.list-item-text {
  flex: 1;
  font-size: 16px;
  color: rgba(170, 179, 187, 1);
  font-weight: 700;
  line-height: 24px;
}

.list-item-arrow {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

/* 列表项展开时样式 */
.list-item-expanded {
  border-radius: 16px 16px 0 0;
  position: relative;
  background-image: url("@/assets/images/chatpreview/list_item_top.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  margin-top: 16px;

  .list-item-content-expanded {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 16px 16px 0 0;
  }

  /* 展开时图标颜色变为深黑色 #002B25 */
  .list-item-icon-expanded .list-icon-img {
    filter: brightness(0) saturate(100%);
  }

  .list-item-text-expanded {
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 43, 37, 1);
  }
}

.list-item-content-area {
  width: 100%;
  min-height: 269px;
  max-height: 473px;
  background: #fff;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 5px rgba(27, 35, 34, 0.2);
  margin-bottom: 5px;
  animation: slideDown 0.3s ease;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* Chrome, Safari, Edge */
  &::-webkit-scrollbar {
    display: none;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  to {
    opacity: 1;
    max-height: 1000px;
  }
}
</style>

<style lang="scss">
  .chat-preview-tooltip {
    max-width: 200px;
    word-break: break-word;
    white-space: normal;
    line-height: 1.5;
    padding: 8px 12px;
    font-size: 13px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 6px;
  }
</style>